import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { authToken, type ApiError } from '@/lib/api';

import { authApi } from '../api/auth.api';
import type { LoginPayload, LoginResponse } from '../types';

/**
 * Mutation de connexion.
 *
 * En cas de succès :
 *  1. le token d'accès est placé en mémoire (jamais dans `localStorage`) ;
 *  2. le cache est vidé — indispensable, sinon les données du compte
 *     précédent resteraient visibles après un changement d'utilisateur sur le
 *     même onglet.
 */
export const useLogin = (
  options: { onSuccess?: (data: LoginResponse) => void } = {},
): UseMutationResult<LoginResponse, ApiError, LoginPayload> => {
  const queryClient = useQueryClient();

  return useMutation<LoginResponse, ApiError, LoginPayload>({
    mutationFn: (payload) => authApi.login(payload),
    onSuccess: (data) => {
      authToken.set(data.accessToken);
      queryClient.clear();
      options.onSuccess?.(data);
    },
  });
};
